// hooks/useDebounce.js
import { useRef, useMemo, useEffect } from 'react';
import debounce from 'lodash/debounce';

export default function useDebounce(callback, delay = 300) {
  const debounceRef = useRef(0);

  const debouncedFn = useMemo(
    () =>
      debounce((...args) => {
        debounceRef.current += 1;
        const localRef = debounceRef.current;

        setTimeout(() => {
          if (localRef === debounceRef.current) {
            callback(...args);
          }
        }, 1);
      }, delay),
    [callback, delay],
  );

  // Cleanup debounce on unmount
  useEffect(
    () => () => {
      debouncedFn.cancel();
    },
    [debouncedFn],
  );

  return debouncedFn;
}
